import team from '../../../../Images/team.jpg';
import Breadcrumb from '../../../Breadcrumb/Breadcrumb';
import MangTeam from '../mangTeam/MangTeam';

const Team = () => {
  return (
    <div>
      <Breadcrumb
        title='Meet Our Expert Teams '
        subTitle='Our Teams '
        slgs='/team'
        img={team}
      ></Breadcrumb>
      <MangTeam />
    </div>
  );
};

export default Team;
